import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { MatMenuItem } from '@angular/material/menu';
import { Router } from '@angular/router';

import { SedsColorMode } from '../../../shared/enums/seds-color-mode.enum';
import { SedsColorModeType } from '../../../shared/types/seds-color-mode.type';
import { HeaderUserData } from './models/header-user-data.model';
import { HeaderUserMenuButton } from './models/header-user-menu-button.model';

@Component({
    selector: 'seds-header-user',
    templateUrl: './seds-header-user.component.html',
    styleUrls: ['./seds-header-user.component.scss'],
    standalone: false
})
export class SedsHeaderUserComponent implements OnChanges {
  @Input() colorMode: SedsColorMode | SedsColorModeType = SedsColorMode.DEFAULT_LIGHT;
  @Input() userData?: HeaderUserData;
  @Output() actionButtonMenuClick = new EventEmitter<HeaderUserMenuButton>();
  @ViewChild('focusItem') menuItemElement!: MatMenuItem;

  public name = '';
  public sizeMenu = 0;
  private readonly window!: Window;

  constructor(public readonly router: Router) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userData']) {
      if (this.userData?.name) {
        this.userData.showAvatar = this.userData.showAvatar !== false && this.userData.name !== undefined;
        this.name = this.userData.name;
      } else {
        console.warn('Review the parameters sent to seds-header-user component! userData.name is required');
      }
      if (this.userData?.avatarImage) {
        this.name = '';
      }
      this.sizeMenu = this.userData?.menuButtonList?.length || 0;
    }
  }

  public clickItemButton(itemMenu: HeaderUserMenuButton): void {
    if (itemMenu.callbackButtonItemClick) {
      this.actionButtonMenuClick.emit(itemMenu);
    } else if (itemMenu.route) {
      this.router.navigate([itemMenu.route]);
    } else if (itemMenu.url) {
      const windowRef = this.getWindow();
      windowRef.location.href = itemMenu.url;
    }
  }

  public getWindow(): Window {
    return window;
  }
}
